import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, CardBody, FormGroup, Input, Label } from 'reactstrap'
import { toast, ToastContainer } from 'react-toastify'
import TitlePage from 'components/atoms/title-page'
import { downloadFile, errorMessage } from './api'
import 'react-toastify/dist/ReactToastify.css'

const BASE = 'api/v2/admins/migration_reports'
const PaymentReportsPage = () => {
  const [ states, setStates ] = useState([])
  const [ selected, setSelected ] = useState([])
  const [ from, setFrom ] = useState('')
  const [ to, setTo ] = useState('')
  const [ loading, setLoading ] = useState(true)
  const [ busy, setBusy ] = useState(false)
  const [ error, setError ] = useState('')
  const operation = useRef(false)
  useEffect(() => {
    let alive = true
    axios.get(`${BASE}/payments/options`)
      .then((response) => { if (alive) setStates(response.data.payment_states || []) })
      .catch(async (err) => { const message = await errorMessage(err); if (alive) setError(message) })
      .finally(() => { if (alive) setLoading(false) })
    return () => { alive = false }
  }, [])
  const download = async (event) => {
    event.preventDefault()
    if (operation.current) return
    if (from && to && from > to) { setError('Paid Date From melebihi Paid Date To.'); return }
    operation.current = true
    setBusy(true); setError('')
    try {
      await downloadFile(`${BASE}/payments/export`, { 'filters[state_in]': selected, 'filters[paid_date_from]': from, 'filters[paid_date_to]': to }, 'Master_Data_Payments.xlsx')
      toast.success('Report Payments berhasil diunduh.')
    } catch (err) { const message = await errorMessage(err); setError(message); toast.error(message) }
    finally { operation.current = false; setBusy(false) }
  }
  return <>
    <ToastContainer position='top-right' autoClose={ 6000 } />
    <TitlePage mainTitle='Finance Team' subTitle='Report Payments' />
    <Card><CardBody><h3>Report Payments Filters</h3>
      <p className='text-muted'>Filter sama seperti dashboard lama. Pilih beberapa Payment Status; kosong berarti semua. Rentang Paid Date inklusif dalam WIB, berdasarkan tanggal pembayaran.</p>
      { error && <div role='alert' className='alert alert-danger'>{ error }</div> }
      <form onSubmit={ download }><fieldset disabled={ busy || loading }>
        <FormGroup><Label for='report-payment-status'>Payment Status</Label><Input id='report-payment-status' type='select' multiple value={ selected } size={ 6 } onChange={ (event) => { const values = Array.from(event.target.selectedOptions).map((option) => option.value); setSelected(values) } }>{ states.map((state) => <option key={ state.value } value={ state.value }>{ state.label }</option>) }</Input><small className='text-muted'>Gunakan Ctrl/Cmd untuk memilih beberapa status.</small></FormGroup>
        <div className='row'><FormGroup className='col-md-6'><Label for='report-paid-from'>Paid Date From</Label><Input id='report-paid-from' type='date' value={ from } onChange={ (event) => setFrom(event.target.value) } /></FormGroup><FormGroup className='col-md-6'><Label for='report-paid-to'>Paid Date To</Label><Input id='report-paid-to' type='date' value={ to } onChange={ (event) => setTo(event.target.value) } /></FormGroup></div>
        <Button color='primary' type='submit'>{ busy ? 'Mengunduh...' : loading ? 'Memuat status...' : 'Download XLSX' }</Button><Button type='button' className='ml-2' onClick={ () => { setSelected([]); setFrom(''); setTo(''); setError('') } }>Reset Filters</Button>
      </fieldset></form>
    </CardBody></Card>
  </>
}

export default PaymentReportsPage
